import UndoButton from "./Undo";

export default {
    button: UndoButton,
    name: "undo",
};
